
import React from "react";
import { Link } from "react-router-dom";
import { cn } from "@/lib/utils";
import { Button } from "@/components/ui/button";
import { useLocation } from "react-router-dom";
import { User, BellDot, Grid, BookOpen, Settings, LogOut } from "lucide-react";
import { useAuth } from "@/contexts/AuthContext";
import { useToast } from "@/hooks/use-toast";

interface LayoutProps {
  children: React.ReactNode;
  className?: string;
}

const Layout = ({ children, className }: LayoutProps) => {
  const location = useLocation();
  const isDashboard = location.pathname === "/dashboard";
  const isShared = location.pathname === "/shared";
  const isUpdates = location.pathname === "/updates";
  const isProfile = location.pathname === "/profile";
  const isSettings = location.pathname === "/instellingen";
  const isIndex = location.pathname === "/" || location.pathname === "/index";
  const { signOut } = useAuth();
  const { toast } = useToast();

  const handleSignOut = async () => {
    try {
      await signOut();
      toast({
        title: "Uitgelogd",
        description: "Je bent succesvol uitgelogd.",
      });
    } catch (error) {
      toast({
        title: "Fout bij uitloggen",
        description: "Er ging iets mis bij het uitloggen.",
        variant: "destructive",
      });
    }
  };

  return (
    <div className="min-h-screen bg-background flex flex-col">
      {(isDashboard || isShared || isUpdates || isProfile || isSettings) && (
        <header className="border-b">
          <div className="mx-auto max-w-7xl flex items-center justify-between px-6 h-16">
            <nav className="flex items-center space-x-4">
              <Button
                variant={isDashboard ? "default" : "ghost"}
                asChild
                className="gap-2"
              >
                <Link to="/">
                  <Grid className="h-4 w-4" />
                  Mijn Plattegronden
                </Link>
              </Button>
              {/* 
              Navigatieknop "Lesideeën" verborgen
              <Button
                variant={isShared ? "default" : "ghost"}
                asChild
                className="gap-2"
              >
                <Link to="/shared">
                  <BookOpen className="h-4 w-4" />
                  Lesideeën
                </Link>
              </Button>
              */}
              {/*
              Navigatieknop "Updates" verborgen
              <Button
                variant={isUpdates ? "default" : "ghost"}
                asChild
                className="gap-2"
              >
                <Link to="/updates">
                  <BellDot className="h-4 w-4" />
                  Updates
                </Link>
              </Button>
              */}
              {/*
              Navigatieknop "Profiel" verborgen
              <Button
                variant={isProfile ? "default" : "ghost"}
                asChild
                className="gap-2"
              >
                <Link to="/profile">
                  <User className="h-4 w-4" />
                  Profiel
                </Link>
              </Button>
              */}
            </nav>
            <div className="flex items-center space-x-2">
              <Button
                variant={isSettings ? "default" : "ghost"}
                asChild
                className="gap-2"
              >
                <Link to="/instellingen">
                  <Settings className="h-4 w-4" />
                  <span className="hidden sm:inline">Instellingen</span>
                </Link>
              </Button>
              <Button
                variant="ghost"
                className="gap-2"
                onClick={handleSignOut}
              >
                <LogOut className="h-4 w-4" />
                <span className="hidden sm:inline">Uitloggen</span>
              </Button>
            </div>
          </div>
        </header>
      )}
      <div className={cn("flex-1", className)}>{children}</div>
      
      {/* Footer - only show on main navigation pages but not on index */}
      {(isDashboard || isShared || isUpdates || isProfile) && (
        <footer className="py-4 border-t mt-auto">
          <div className="text-center text-muted-foreground text-sm">
            Made with <span className="text-green-500">💚</span> by{" "}
            <a 
              href="https://beterturnen.nl/turnles-planner" 
              target="_blank" 
              rel="noopener noreferrer"
              className="hover:underline hover:text-primary transition-colors"
            >
              Beter Turnen
            </a>
          </div>
        </footer>
      )}
    </div>
  );
}

export default Layout;
